module.exports = __webpack_public_path__ + "static/media/prism-johnson.dc8dc26f.svg";